import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ReadingGuideIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 28 29",
    fill: "none",
    stroke: color,
    strokeWidth: strokeWidth,
    children: [/*#__PURE__*/jsx("path", {
      d: "M14 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm9 9c.552 0 1-.895 1-2s-.448-2-1-2-1 .895-1 2 .448 2 1 2Z",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/jsx("path", {
      d: "M23 15.974v-1.571a1 1 0 0 0-1.326-.946l-7 2.414a1 1 0 0 0-.674.945v9.781a1 1 0 0 0 1.326.946l7-2.414a1 1 0 0 0 .674-.945v-2.262",
      strokeLinecap: "round",
      vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/jsx("path", {
      d: "M5 21c-.552 0-1-.895-1-2s.448-2 1-2 1 .895 1 2-.448 2-1 2Z",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/jsx("path", {
      d: "M5 15.974v-1.571a1 1 0 0 1 1.326-.946l7 2.414a1 1 0 0 1 .674.945v9.781a1 1 0 0 1-1.326.946l-7-2.414A1 1 0 0 1 5 24.184v-2.262",
      strokeLinecap: "round",
      vectorEffect: "non-scaling-stroke"
    })]
  });
};

export { PM2ReadingGuideIcon };
//# sourceMappingURL=reading-guide.js.map
